/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AcceptanceDeadline } from './AcceptanceDeadline';
import {
    AcceptanceDeadlineFromJSON,
    AcceptanceDeadlineFromJSONTyped,
    AcceptanceDeadlineToJSON,
} from './AcceptanceDeadline';
import type { AdditionalTerms1 } from './AdditionalTerms1';
import {
    AdditionalTerms1FromJSON,
    AdditionalTerms1FromJSONTyped,
    AdditionalTerms1ToJSON,
} from './AdditionalTerms1';
import type { AppraisalPeriodDays } from './AppraisalPeriodDays';
import {
    AppraisalPeriodDaysFromJSON,
    AppraisalPeriodDaysFromJSONTyped,
    AppraisalPeriodDaysToJSON,
} from './AppraisalPeriodDays';
import type { BuyerAgentCommissionFlatCents } from './BuyerAgentCommissionFlatCents';
import {
    BuyerAgentCommissionFlatCentsFromJSON,
    BuyerAgentCommissionFlatCentsFromJSONTyped,
    BuyerAgentCommissionFlatCentsToJSON,
} from './BuyerAgentCommissionFlatCents';
import type { BuyerAgentCommissionPercentage1 } from './BuyerAgentCommissionPercentage1';
import {
    BuyerAgentCommissionPercentage1FromJSON,
    BuyerAgentCommissionPercentage1FromJSONTyped,
    BuyerAgentCommissionPercentage1ToJSON,
} from './BuyerAgentCommissionPercentage1';
import type { ClientProposedTermsRequestBuyerAgentCommissionSource } from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import {
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON,
    ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSONTyped,
    ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON,
} from './ClientProposedTermsRequestBuyerAgentCommissionSource';
import type { ClosingDate } from './ClosingDate';
import {
    ClosingDateFromJSON,
    ClosingDateFromJSONTyped,
    ClosingDateToJSON,
} from './ClosingDate';
import type { ConcessionsFlatCents } from './ConcessionsFlatCents';
import {
    ConcessionsFlatCentsFromJSON,
    ConcessionsFlatCentsFromJSONTyped,
    ConcessionsFlatCentsToJSON,
} from './ConcessionsFlatCents';
import type { ConcessionsPercentage1 } from './ConcessionsPercentage1';
import {
    ConcessionsPercentage1FromJSON,
    ConcessionsPercentage1FromJSONTyped,
    ConcessionsPercentage1ToJSON,
} from './ConcessionsPercentage1';
import type { CreateOfferRequestSource } from './CreateOfferRequestSource';
import {
    CreateOfferRequestSourceFromJSON,
    CreateOfferRequestSourceFromJSONTyped,
    CreateOfferRequestSourceToJSON,
} from './CreateOfferRequestSource';
import type { DueDiligenceFee } from './DueDiligenceFee';
import {
    DueDiligenceFeeFromJSON,
    DueDiligenceFeeFromJSONTyped,
    DueDiligenceFeeToJSON,
} from './DueDiligenceFee';
import type { DueDiligencePeriodDays } from './DueDiligencePeriodDays';
import {
    DueDiligencePeriodDaysFromJSON,
    DueDiligencePeriodDaysFromJSONTyped,
    DueDiligencePeriodDaysToJSON,
} from './DueDiligencePeriodDays';
import type { EarnestMoneyDeposit } from './EarnestMoneyDeposit';
import {
    EarnestMoneyDepositFromJSON,
    EarnestMoneyDepositFromJSONTyped,
    EarnestMoneyDepositToJSON,
} from './EarnestMoneyDeposit';
import type { FinancingPeriodDays } from './FinancingPeriodDays';
import {
    FinancingPeriodDaysFromJSON,
    FinancingPeriodDaysFromJSONTyped,
    FinancingPeriodDaysToJSON,
} from './FinancingPeriodDays';
import type { FinancingTypes } from './FinancingTypes';
import {
    FinancingTypesFromJSON,
    FinancingTypesFromJSONTyped,
    FinancingTypesToJSON,
} from './FinancingTypes';
import type { OfferPrice } from './OfferPrice';
import {
    OfferPriceFromJSON,
    OfferPriceFromJSONTyped,
    OfferPriceToJSON,
} from './OfferPrice';
import type { RequestSellerConcessions } from './RequestSellerConcessions';
import {
    RequestSellerConcessionsFromJSON,
    RequestSellerConcessionsFromJSONTyped,
    RequestSellerConcessionsToJSON,
} from './RequestSellerConcessions';
import type { TermsStatus } from './TermsStatus';
import {
    TermsStatusFromJSON,
    TermsStatusFromJSONTyped,
    TermsStatusToJSON,
} from './TermsStatus';
import type { TitleCompany } from './TitleCompany';
import {
    TitleCompanyFromJSON,
    TitleCompanyFromJSONTyped,
    TitleCompanyToJSON,
} from './TitleCompany';

/**
 * 
 * @export
 * @interface UpdateOfferTermsRequest
 */
export interface UpdateOfferTermsRequest {
    /**
     * 
     * @type {OfferPrice}
     * @memberof UpdateOfferTermsRequest
     */
    offerPrice?: OfferPrice;
    /**
     * 
     * @type {FinancingTypes}
     * @memberof UpdateOfferTermsRequest
     */
    financingTypes?: FinancingTypes;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferTermsRequest
     */
    downPayment?: number;
    /**
     * 
     * @type {EarnestMoneyDeposit}
     * @memberof UpdateOfferTermsRequest
     */
    earnestMoneyDeposit?: EarnestMoneyDeposit;
    /**
     * 
     * @type {ClosingDate}
     * @memberof UpdateOfferTermsRequest
     */
    closingDate?: ClosingDate;
    /**
     * 
     * @type {TitleCompany}
     * @memberof UpdateOfferTermsRequest
     */
    titleCompany?: TitleCompany;
    /**
     * 
     * @type {DueDiligencePeriodDays}
     * @memberof UpdateOfferTermsRequest
     */
    dueDiligencePeriodDays?: DueDiligencePeriodDays;
    /**
     * 
     * @type {ClientProposedTermsRequestBuyerAgentCommissionSource}
     * @memberof UpdateOfferTermsRequest
     */
    buyerAgentCommissionSource?: ClientProposedTermsRequestBuyerAgentCommissionSource;
    /**
     * 
     * @type {BuyerAgentCommissionFlatCents}
     * @memberof UpdateOfferTermsRequest
     */
    buyerAgentCommissionFlatCents?: BuyerAgentCommissionFlatCents;
    /**
     * 
     * @type {BuyerAgentCommissionPercentage1}
     * @memberof UpdateOfferTermsRequest
     */
    buyerAgentCommissionPercentage?: BuyerAgentCommissionPercentage1;
    /**
     * 
     * @type {DueDiligenceFee}
     * @memberof UpdateOfferTermsRequest
     */
    dueDiligenceFee?: DueDiligenceFee;
    /**
     * 
     * @type {RequestSellerConcessions}
     * @memberof UpdateOfferTermsRequest
     */
    requestSellerConcessions?: RequestSellerConcessions;
    /**
     * 
     * @type {ConcessionsFlatCents}
     * @memberof UpdateOfferTermsRequest
     */
    concessionsFlatCents?: ConcessionsFlatCents;
    /**
     * 
     * @type {ConcessionsPercentage1}
     * @memberof UpdateOfferTermsRequest
     */
    concessionsPercentage?: ConcessionsPercentage1;
    /**
     * 
     * @type {AdditionalTerms1}
     * @memberof UpdateOfferTermsRequest
     */
    additionalTerms?: AdditionalTerms1;
    /**
     * 
     * @type {AcceptanceDeadline}
     * @memberof UpdateOfferTermsRequest
     */
    acceptanceDeadline?: AcceptanceDeadline;
    /**
     * 
     * @type {AppraisalPeriodDays}
     * @memberof UpdateOfferTermsRequest
     */
    appraisalPeriodDays?: AppraisalPeriodDays;
    /**
     * 
     * @type {FinancingPeriodDays}
     * @memberof UpdateOfferTermsRequest
     */
    financingPeriodDays?: FinancingPeriodDays;
    /**
     * 
     * @type {CreateOfferRequestSource}
     * @memberof UpdateOfferTermsRequest
     */
    source?: CreateOfferRequestSource;
    /**
     * 
     * @type {TermsStatus}
     * @memberof UpdateOfferTermsRequest
     */
    termsStatus?: TermsStatus;
}

/**
 * Check if a given object implements the UpdateOfferTermsRequest interface.
 */
export function instanceOfUpdateOfferTermsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateOfferTermsRequestFromJSON(json: any): UpdateOfferTermsRequest {
    return UpdateOfferTermsRequestFromJSONTyped(json, false);
}

export function UpdateOfferTermsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOfferTermsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offerPrice': !exists(json, 'offer_price') ? undefined : OfferPriceFromJSON(json['offer_price']),
        'financingTypes': !exists(json, 'financing_types') ? undefined : FinancingTypesFromJSON(json['financing_types']),
        'downPayment': !exists(json, 'down_payment') ? undefined : json['down_payment'],
        'earnestMoneyDeposit': !exists(json, 'earnest_money_deposit') ? undefined : EarnestMoneyDepositFromJSON(json['earnest_money_deposit']),
        'closingDate': !exists(json, 'closing_date') ? undefined : ClosingDateFromJSON(json['closing_date']),
        'titleCompany': !exists(json, 'title_company') ? undefined : TitleCompanyFromJSON(json['title_company']),
        'dueDiligencePeriodDays': !exists(json, 'due_diligence_period_days') ? undefined : DueDiligencePeriodDaysFromJSON(json['due_diligence_period_days']),
        'buyerAgentCommissionSource': !exists(json, 'buyer_agent_commission_source') ? undefined : ClientProposedTermsRequestBuyerAgentCommissionSourceFromJSON(json['buyer_agent_commission_source']),
        'buyerAgentCommissionFlatCents': !exists(json, 'buyer_agent_commission_flat_cents') ? undefined : BuyerAgentCommissionFlatCentsFromJSON(json['buyer_agent_commission_flat_cents']),
        'buyerAgentCommissionPercentage': !exists(json, 'buyer_agent_commission_percentage') ? undefined : BuyerAgentCommissionPercentage1FromJSON(json['buyer_agent_commission_percentage']),
        'dueDiligenceFee': !exists(json, 'due_diligence_fee') ? undefined : DueDiligenceFeeFromJSON(json['due_diligence_fee']),
        'requestSellerConcessions': !exists(json, 'request_seller_concessions') ? undefined : RequestSellerConcessionsFromJSON(json['request_seller_concessions']),
        'concessionsFlatCents': !exists(json, 'concessions_flat_cents') ? undefined : ConcessionsFlatCentsFromJSON(json['concessions_flat_cents']),
        'concessionsPercentage': !exists(json, 'concessions_percentage') ? undefined : ConcessionsPercentage1FromJSON(json['concessions_percentage']),
        'additionalTerms': !exists(json, 'additional_terms') ? undefined : AdditionalTerms1FromJSON(json['additional_terms']),
        'acceptanceDeadline': !exists(json, 'acceptance_deadline') ? undefined : AcceptanceDeadlineFromJSON(json['acceptance_deadline']),
        'appraisalPeriodDays': !exists(json, 'appraisal_period_days') ? undefined : AppraisalPeriodDaysFromJSON(json['appraisal_period_days']),
        'financingPeriodDays': !exists(json, 'financing_period_days') ? undefined : FinancingPeriodDaysFromJSON(json['financing_period_days']),
        'source': !exists(json, 'source') ? undefined : CreateOfferRequestSourceFromJSON(json['source']),
        'termsStatus': !exists(json, 'terms_status') ? undefined : TermsStatusFromJSON(json['terms_status']),
    };
}

export function UpdateOfferTermsRequestToJSON(value?: UpdateOfferTermsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offer_price': OfferPriceToJSON(value.offerPrice),
        'financing_types': FinancingTypesToJSON(value.financingTypes),
        'down_payment': value.downPayment,
        'earnest_money_deposit': EarnestMoneyDepositToJSON(value.earnestMoneyDeposit),
        'closing_date': ClosingDateToJSON(value.closingDate),
        'title_company': TitleCompanyToJSON(value.titleCompany),
        'due_diligence_period_days': DueDiligencePeriodDaysToJSON(value.dueDiligencePeriodDays),
        'buyer_agent_commission_source': ClientProposedTermsRequestBuyerAgentCommissionSourceToJSON(value.buyerAgentCommissionSource),
        'buyer_agent_commission_flat_cents': BuyerAgentCommissionFlatCentsToJSON(value.buyerAgentCommissionFlatCents),
        'buyer_agent_commission_percentage': BuyerAgentCommissionPercentage1ToJSON(value.buyerAgentCommissionPercentage),
        'due_diligence_fee': DueDiligenceFeeToJSON(value.dueDiligenceFee),
        'request_seller_concessions': RequestSellerConcessionsToJSON(value.requestSellerConcessions),
        'concessions_flat_cents': ConcessionsFlatCentsToJSON(value.concessionsFlatCents),
        'concessions_percentage': ConcessionsPercentage1ToJSON(value.concessionsPercentage),
        'additional_terms': AdditionalTerms1ToJSON(value.additionalTerms),
        'acceptance_deadline': AcceptanceDeadlineToJSON(value.acceptanceDeadline),
        'appraisal_period_days': AppraisalPeriodDaysToJSON(value.appraisalPeriodDays),
        'financing_period_days': FinancingPeriodDaysToJSON(value.financingPeriodDays),
        'source': CreateOfferRequestSourceToJSON(value.source),
        'terms_status': TermsStatusToJSON(value.termsStatus),
    };
}

